import { render, staticRenderFns } from "./NewAccountSelector.vue?vue&type=template&id=0a548e33"
import script from "./NewAccountSelector.vue?vue&type=script&lang=js"
export * from "./NewAccountSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccountSelector: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/AccountSelector.vue').default,CircleSelector: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/CircleSelector.vue').default})
